import React from "react";

import avatar_1 from "../assets/img/avatars/1.png";
import avatar_2 from "../assets/img/avatars/2.png";
import avatar_3 from "../assets/img/avatars/3.png";
import avatar_4 from "../assets/img/avatars/4.png";
import avatar_5 from "../assets/img/avatars/5.png";
import avatar_6 from "../assets/img/avatars/6.png";
import avatar_7 from "../assets/img/avatars/7.png";
import avatar_8 from "../assets/img/avatars/8.png";

export const AVATAR_1 = {
  codigo: 1,
  nome: "Avatar 1",
  icone: <img src={avatar_1} alt="" className="img-thumbnail img-circle img-fluid" />,
  url: avatar_1
};
export const AVATAR_2 = {
  codigo: 2,
  nome: "Avatar 2",
  icone: <img src={avatar_2} alt="" className="img-thumbnail img-circle img-fluid" />,
  url: avatar_2
};
export const AVATAR_3 = {
  codigo: 3,
  nome: "Avatar 3",
  icone: <img src={avatar_3} alt="" className="img-thumbnail img-circle img-fluid" />,
  url: avatar_3
};
export const AVATAR_4 = {
  codigo: 4,
  nome: "Avatar 4",
  icone: <img src={avatar_4} alt="" className="img-thumbnail img-circle img-fluid" />,
  url: avatar_4
};
export const AVATAR_5 = {
  codigo: 5,
  nome: "Avatar 5",
  icone: <img src={avatar_5} alt="" className="img-thumbnail img-circle img-fluid" />,
  url: avatar_5
};
export const AVATAR_6 = {
  codigo: 6,
  nome: "Avatar 6",
  icone: <img src={avatar_6} alt="" className="img-thumbnail img-circle img-fluid" />,
  url: avatar_6
};
export const AVATAR_7 = {
  codigo: 7,
  nome: "Avatar 7",
  icone: <img src={avatar_7} alt="" className="img-thumbnail img-circle img-fluid" />,
  url: avatar_7
};
export const AVATAR_8 = {
  codigo: 8,
  nome: "Avatar 8",
  icone: <img src={avatar_8} alt="" className="img-thumbnail img-circle img-fluid" />,
  url: avatar_8
};

export const values = [AVATAR_1, AVATAR_2, AVATAR_3, AVATAR_4, AVATAR_5, AVATAR_6, AVATAR_7, AVATAR_8];

export const valueOf = codigo => {
  for (let i = 0; i < values.length; i++) {
    const cs = values[i];
    if (cs.codigo === parseInt(codigo, 0)) {
      return cs;
    }
  }

  return AVATAR_1;
};



// WEBPACK FOOTER //
// ./src/constantes/CsAvatars.js